export var AppLoadingState;
(function (AppLoadingState) {
    AppLoadingState[AppLoadingState["Null"] = 0] = "Null";
    AppLoadingState[AppLoadingState["LoadingScreen"] = 1] = "LoadingScreen";
    AppLoadingState[AppLoadingState["AppScreen"] = 2] = "AppScreen";
    AppLoadingState[AppLoadingState["ErrorScreen"] = 3] = "ErrorScreen";
})(AppLoadingState || (AppLoadingState = {}));
var DataObjectInfo = /** @class */ (function () {
    function DataObjectInfo() {
    }
    return DataObjectInfo;
}());
export { DataObjectInfo };
export var SettingsTabs = {
    None: 'none',
    Theme: 'theme',
    Language: 'language',
    Login: 'login',
    UserInfo: 'profile',
    About: 'about',
};
// TODO MLT component shoudl use this
export function LocalText(text, locale) {
    if (!text) {
        return undefined;
    }
    if (typeof text === 'string') {
        return text;
    }
    if (locale === 'cs' && text.cs) {
        return text.cs;
    }
    if (locale === 'en' && text.en) {
        return text.en;
    }
    return text.en || text.cs || text.default || undefined;
}
export var OverlayType;
(function (OverlayType) {
    OverlayType[OverlayType["Null"] = 0] = "Null";
    OverlayType[OverlayType["Error"] = 1] = "Error";
    OverlayType[OverlayType["Notification"] = 2] = "Notification";
    OverlayType[OverlayType["Navigation"] = 3] = "Navigation";
    OverlayType[OverlayType["FrameRegister"] = 4] = "FrameRegister";
})(OverlayType || (OverlayType = {}));
